import React from 'react';

const Checkbox = ({ id, checked, onChange, label }) => (
  <label
    htmlFor={id}
    className="flex items-start cursor-pointer font-normal text-base text-gray-600"
  >
    <input
      id={id}
      className="mt-1 mr-2"
      type="checkbox"
      checked={checked}
      onChange={onChange}
    />
    {label}
  </label>
);

export default Checkbox;
